import { DigitalTwinLicence } from "@iventis/domain-model/model/digitalTwinLicence";
import { EngineInterpreterOptions } from "../../types/internal";

export interface UnrealEngineOptions extends EngineInterpreterOptions {
    getIpAddress: (digitalTwinLicence: DigitalTwinLicence) => Promise<string>;
    projectId: string;
    apiURL: string;
    getApiKey: () => Promise<string>;
    showReconnecting: (isConnecting: boolean) => void;
    exitMappingEngine: (error: UnrealEngineErrors) => void;
}

export enum UnrealEngineErrors {
    ENGINE_ERROR = "ENGINE_ERROR",
    CONNECTION_FAILED = "CONNECTION_FAILED",
    OCCUPIED = "OCCUPIED",
    AFK_TIMEOUT = "AFK_TIMEOUT",
}
